/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface PayRunIdRequest
 */
export interface PayRunIdRequest {
  /**
   *
   * @type {string}
   * @memberof PayRunIdRequest
   */
  payRunId: string;
}

/**
 * Check if a given object implements the PayRunIdRequest interface.
 */
export function instanceOfPayRunIdRequest(
  value: object,
): value is PayRunIdRequest {
  if (!("payRunId" in value) || value["payRunId"] === undefined) return false;
  return true;
}

export function PayRunIdRequestFromJSON(json: any): PayRunIdRequest {
  return PayRunIdRequestFromJSONTyped(json, false);
}

export function PayRunIdRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): PayRunIdRequest {
  if (json == null) {
    return json;
  }
  return {
    payRunId: json["payRunId"],
  };
}

export function PayRunIdRequestToJSON(json: any): PayRunIdRequest {
  return PayRunIdRequestToJSONTyped(json, false);
}

export function PayRunIdRequestToJSONTyped(
  value?: PayRunIdRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    payRunId: value["payRunId"],
  };
}
